module.exports = __webpack_public_path__ + "static/media/paper-snip-1.8c914dfb.png";